<template>
    <transition name="form">
        <div v-if="isOpen">
            <div class="fixed inset-0 items-center justify-center w-screen h-screen z-100 sm:flex overflow-scroll sm:overflow-auto my-10 sm:my-0">
                <button class="absolute z-100 md:top-10 right-5 md:right-10" @click="toggleOverlay()">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="text-white fill-current h-8 w-8"><path data-v-3fc34e57="" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path></svg>
                </button>
                <button class="fixed inset-0 w-screen h-screen text-6xl bg-blue-900 opacity-90" @click="toggleOverlay()"></button>
                <div class="relative z-0 flex justify-center flex-col md:flex-row my-16 md:my-0">
                    <div class="mx-5 mb-10 text-blue-700 bg-white rounded-lg shadow-xl text-lg lg:max-w-sm sm:mb-0 z-0 relative flex-col justify-between flex" v-for="employee in modalEmployees">
                        <div class="top">
                            <div class="flex items-center h-32 px-4 rounded-t-lg purple-gradient">
                                <div class="flex-grow w-auto pl-4 text-center text-white sm:text-left">
                                    <div class="flex flex-col-reverse sm:block">
                                        <p class="text-xl font-semibold " v-text="employee.title" />
                                        <span class="inline text-sm sm:text-lg sm:block"><span class="mx-1 sm:hidden">at</span><span v-text="employee.employee_company.title"></span></span>
                                        <p class="text-sm sm:block" v-text="employee.employee_business_function" />
                                    </div>
                                </div>
                            </div>
                            <div class="p-4">
                                <p class="mb-3 font-semibold text-blue-600">Company Introduction</p>
                                <span v-text="employee.employee_company_introduction" />
                            </div>
                        </div>
                        <div class="bottom">
                            <hr class="border-blue-100"/>
                            <div class="p-4">
                                <p class="mb-3 font-semibold text-blue-600">Contact</p>
                                <div class="flex mb-3">
                                    <div class="w-2/12">Phone:</div>
                                    <div class="w-10/12"><a :href="'tel:'+ employee.employee_phone_number_clean" class="hover:underline" title="Call">{{ employee.employee_phone_number }}</a></div>
                                </div>
                                <div class="flex mb-3">
                                    <div class="w-2/12">Email:</div>
                                    <div class="w-10/12"><a :href="'mailto:' + employee.employee_mail" class="hover:underline" title="Mail">{{ employee.employee_mail }}</a></div>
                                </div>
                            </div>
                            <template v-if="employee.employee_linkedin_url">
                                <hr class="border-blue-100"/>
                                <div class="flex justify-center px-8 py-3 rounded-b-lg" style="background: #F7F9FB;">
                                    <a :href="employee.employee_linkedin_url" target="_blank" title="Visit me on LinkedIn" class="block px-6 py-2 text-sm font-semibold text-center text-white rounded hover:text-blue-200" style="background: #0077B5;">Visit me on LinkedIn</a>
                                </div>
                            </template>
                        </div>

                    </div>
                </div>


            </div>
        </div>

    </transition>

</template>

<script>
    export default {
        name: "Employee-Popup",
        props: {
            modalEmployees: Array
        },
        data() {
            return {
                isOpen: false,
            };
        },
        mounted() {
            EventBus.$on('open-employee-modal', () => {
                this.isOpen = true;
                if (this.isOpen === false) {
                    document.body.classList.remove("overflow-hidden");
                    return;
                }
                document.body.classList.add("overflow-hidden");
            });
        },
        methods: {
            toggleOverlay() {
                this.isOpen = !this.isOpen;
                if (this.isOpen === false) {
                    document.body.classList.remove("overflow-hidden");
                    return;
                }
                document.body.classList.add("overflow-hidden");
            },
        }
    }
</script>
<style scoped>

</style>
